import Swiper, { Navigation, Autoplay, EffectCreative } from 'swiper';
import { swiperObserver } from '../utils/swiper.utils.js';

// our graduates

let ourGraduatesSwiperWr = document.querySelectorAll('.our-graduates-slider-wr');

ourGraduatesSwiperWr?.forEach((el) => {
  if (el) {
    let swiperEl = el.querySelector('.swiper');
    let parentEl = el.parentElement;
    let nextEl = parentEl.querySelector('.swiper-button-next');
    let prevEl = parentEl.querySelector('.swiper-button-prev');
    let wrapper = swiperEl.querySelector('.swiper-wrapper');

    let swiper = new Swiper(swiperEl, {
      modules: [Autoplay, Navigation, EffectCreative],
      grabCursor: true,
      effect: "creative",
      speed: 600,
      allowTouchMove: true,
      creativeEffect: {
        perspective: true,
        limitProgress: 1,
        prev: {
          shadow: true,
          translate: [0, 0, -400],
        },
        next: {
          translate: ["15%", 0, -200],
          rotate: [0, 0, 4],
          shadow: true,
        },
      },
      navigation: {
        nextEl: nextEl,
        prevEl: prevEl,
      },
      // breakpoints: {
      //   1024: {
      //     allowTouchMove: false,
      //   }
      // },
      autoplay: {
        delay: 3000,
        disableOnInteraction: false,
        pauseOnMouseEnter: window.innerWidth > 1024,
      },
    });

    swiperObserver(swiper);
  }
});
